const escapeHtmlAttr = (value) =>
	String(value ?? '')
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;');

/** Build a PDP URL that always deeplinks to a saved design, never a variant. */
const getDesignProductUrl = (design, prodObj) => {
	const sessionMetadata = design?.session_metadata || design?.sessionMetadata;
	const designId = design?.design_id;
	if (!designId) return '#';

	if (sessionMetadata?.addToCart) {
		return `${sessionMetadata.addToCart}${designId}`;
	}

	const handle =
		sessionMetadata?.productHandle ||
		design?.product?.handle ||
		prodObj?.productHandle;

	if (handle) {
		return `${window.location.origin}/products/${handle}?design=${designId}`;
	}

	return `${window.location.origin}${window.location.pathname}?design=${designId}`;
};

/** UnitMOQ design payloads use different thumbnail keys across API versions. */
const getDesignPreviewUrl = (design) => {
	if (!design) return '';
	return (
		design.image_url ||
		design.imageUrl ||
		design.thumbnail ||
		design.image ||
		design.product?.thumbnail ||
		design.options?.[0]?.thumbnail ||
		design.options?.[0]?.image ||
		''
	);
};

function savedDesignsInit() {
	let umoq = window.UnitMOQ;
	let umoqSession = umoq?.beta?.session;
	let prodObj = $('.product')?.data('obj');
	let productId = prodObj?.productId;
	let urlParams = new URLSearchParams(window.location.search);
	let designId = urlParams.get('design');
	let savedDesigns = umoqSession?.getDesigns();
	const customerId = prodObj?.customerId;
	if (customerId) {
		umoq?.setDesignerId(customerId);
	}

	/**
	 * Helper for loading UnitMOQ products and avoiding the same product being loaded twice.
	 * In most cases, that would be undesiredable. There is an edge where a customer may be attempting
	 * to reload a variant after they have modified it. However, the current UI does not support this
	 * interaction at the moment. - JRH (03/23/26)
	 */
	let curUmoqDesignIdOrSku = null;
	const loadUnitMoqProductPreview = (designIdOrSku) => {
		console.group('loadUnitMoqProductPreview', {designIdOrSku, curUmoqDesignIdOrSku})
		if (curUmoqDesignIdOrSku === designIdOrSku) {
			console.log('Requested designIdOrSku already loaded');
			console.groupEnd();
			return; // Already loaded.
		}

		curUmoqDesignIdOrSku = designIdOrSku;
		umoq.loadPreview(curUmoqDesignIdOrSku);

		console.groupEnd();
	}

	const uncheckVariantSwatches = () => window.uncheckVariantSwatches?.();

	const selectSavedDesignOnPdp = (id) => {
		const currentDesignEl = document.querySelector(
			`.design-options-container .option-item[data-design-id="${id}"]`
		);
		if (!currentDesignEl) return false;

		uncheckVariantSwatches();
		$('.design-options-container .option-item.is-design input:checked')
			.prop('checked', false)
			.removeAttr('checked');
		loadUnitMoqProductPreview(id);
		$(currentDesignEl).find('input').prop('checked', true);
		$(currentDesignEl).find('label').click();
		return true;
	};

	const handleDeeplinkingToDesign = () => {
		urlParams = new URLSearchParams(window.location.search);
		designId = urlParams.get('design');
		const variantId = urlParams.get('variant');

		if (designId) {
			if (variantId) {
				urlParams.delete('variant');
				window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
			}

			uncheckVariantSwatches();
			loadUnitMoqProductPreview(designId);

			if (!selectSavedDesignOnPdp(designId)) {
				let attempts = 0;
				const waitForDesignSwatch = setInterval(() => {
					attempts += 1;
					if (selectSavedDesignOnPdp(designId) || attempts >= 20) {
						clearInterval(waitForDesignSwatch);
					}
				}, 250);
			}
			return;
		}

		if (variantId) {
			loadUnitMoqProductPreview(variantId);
			const $option = $(`.option-item[data-variant-id="${variantId}"]`);
			$option.find('input').prop('checked', false);
			$option.find('label').click();
			if ($option.is('.is-rts') || !$option.is(':visible')) {
				console.log('clicking color options more');
				$('.color-options-more').click();
			}
		}
	}

	const renderItems = () => {
		const isPDP = document.querySelector('.product');
		umoq = window.UnitMOQ;
		umoqSession = umoq?.beta?.session;
		savedDesigns = umoqSession?.getDesigns();
		const currentDesign = savedDesigns?.find(design => design?.design_id == designId);
		let currentProductDesigns = "";
		urlParams = new URLSearchParams(window.location.search);
		designId = urlParams.get('design');
		$(".saved-designs-drawer__item").remove();
		savedDesigns?.forEach(design => {
			const sessionMetadata = design?.session_metadata || design?.sessionMetadata;
			const link = getDesignProductUrl(design, prodObj);
			const name = sessionMetadata?.designName || design.name.replace(/^Custom\s+/i, '');
			const price = `$${(design.price / 100).toString().replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1')}`;
			const dataString = JSON.stringify(design)?.replace(/"/g, '&quot;');
			const isSelected = currentDesign?.design_id === design.design_id;
			const color = design.options?.[0]?.label || design.name || 'Custom';
			const previewUrl = getDesignPreviewUrl(design);
			$(".saved-designs-drawer__panel").append(`
				<div class='saved-designs-drawer__item' data-saved-product-design-id='${design.design_id}'>
					<a class='saved-designs-drawer__item-media' href='${link}' aria-label='View ${name}'>
						<img class='saved-designs-drawer__item-image' src='${escapeHtmlAttr(previewUrl)}' alt='${escapeHtmlAttr(name)}' loading='lazy' width='120' height='120'/>
					</a>
					<div class='saved-designs-drawer__item-detail'>
					<a class='saved-designs-drawer__item-title' href='${link}' aria-label='View ${name}'>${name}</a>
					<div class='saved-designs-drawer__item-price'>Designed at ${price}</div>
						<a class='saved-designs-drawer__item-btn' href='${link}' aria-label='View Design'>View Design</a>
					</div>
					<button class='saved-designs-drawer__item-remove' aria-label='Remove Item'></button>
				</div>
			`);
			if (productId && sessionMetadata?.productId == productId) {
				const variantOptionName =
					document.querySelector(
						'variant-selects .color-options-container .option-item:not(.is-design) input[type="radio"]'
					)?.name || 'Color';
				const swatchImg = previewUrl
					? `<img class="color-swatch__image" src="${escapeHtmlAttr(previewUrl)}" alt="" loading="lazy" width="120" height="120">`
					: '';
				currentProductDesigns += `
					<div class="option-item is-design${isSelected ? ' is-selected' : ''}" data-ATC="${sessionMetadata?.addToCart}${design.design_id}" data-design-id="${design.design_id}" data-sku="${design.design_id}"> 
						<svg class="icon icon-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path> </svg>
						<input type="radio" id="template--${productId}__custom-${design.design_id}" name="${escapeHtmlAttr(variantOptionName)}" value="${escapeHtmlAttr(color)}" form="product-form-template--${productId}__main" class="saved-design-input"${isSelected ? ' checked' : ''}>
						<label design-data="${dataString}" data-price="${price}" data-ATC="${sessionMetadata?.addToCart}${design.design_id}" data-color="${escapeHtmlAttr(color)}" class="color-swatch variant-swatch round" for="template--${productId}__custom-${design.design_id}">
							${swatchImg}
							<span class="visually-hidden">Custom Design</span>
						</label>
					</div>
				`;
			}
		});
		const $savedDesignsPicker = $('.saved-designs-picker');
		if (isPDP && currentProductDesigns !== "") {
			$(".design-options-container")?.html(currentProductDesigns);
			$savedDesignsPicker?.addClass('shown');
		} else if (isPDP) {
			$savedDesignsPicker?.removeClass('shown');
		}
		if ($(".saved-designs-drawer__item").length) {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--empty");
		} else {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--active").addClass("saved-designs-drawer--empty");
		}
		handleDeeplinkingToDesign();
	}

	$(".saved-designs-drawer").on("click", ".saved-designs-drawer__item-remove", function (e) {
		e.preventDefault();
		const item = $(this).parents(".saved-designs-drawer__item"),
			itemId = item.attr('data-saved-product-design-id'),
			variantEl = document.querySelector(
				`.design-options-container .option-item[data-design-id="${itemId}"]`
			);
		umoqSession.removeDesign(itemId);
		if (!document.querySelectorAll('.design-options-container .option-item.is-design').length) {
			$('.saved-designs-picker')?.removeClass('shown');
			$('.saved-designs-drawer')?.addClass('saved-designs-drawer--empty');
		}
		if (variantEl) {
			variantEl.remove();
		}
		item.remove();
	});

	$(".saved-designs-drawer__tab").on("click", function () {
		if ($(".saved-designs-drawer").hasClass("saved-designs-drawer--active")) {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--active");
			$("body").removeClass("saved-designs-drawer--active");
		} else {
			$(".saved-designs-drawer").addClass("saved-designs-drawer--active");
			$("body").addClass("saved-designs-drawer--active");
		}
	});
	$(".saved-designs-drawer .drawer__close").on("click", function () {
		$(".saved-designs-drawer").removeClass("saved-designs-drawer--active");
		$("body").removeClass("saved-designs-drawer--active");
	});

	// JRH Update (03/23/26) - Listen for EVENT_DESIGN_LOADED instead of EVENT_LOADED for quicker UI.
	window.UnitMOQ.on(window.UnitMOQ.EVENT_DESIGN_LOADED, (e) => {
		renderItems();
		if (new URLSearchParams(window.location.search).get('design')) {
			uncheckVariantSwatches();
		}
		$('.variant-loader').hide();
		$('.gallery-wrap').removeClass('hidden');
		$('.gallery-image').addClass('hidden');
	});

	window.UnitMOQ.on(window.UnitMOQ.EVENT_SAVED, (e) => {
		renderItems();
	});

	// const allEventObjects = Object.entries({...window.UnitMOQ, ...window.UnitMOQ?.beta?.session}).filter(([key]) => key.startsWith('EVENT_'));
	// allEventObjects.forEach(([key, value]) => {
	// 	const eventParent = value.includes('-session-') ? window.UnitMOQ?.beta?.session : window.UnitMOQ;
	// 	eventParent?.on(value, (e) => {
	// 		console.log(key, value);
	// 	});
	// });

	window.UnitMOQ.beta.session.on(window.UnitMOQ.beta.session.EVENT_DESIGN_ADDED, (data) => {
		const design = data?.detail;
		prodObj = $('.product')?.data('obj');
		if (design) {
			//replace variant with design in url without reloading the page
			const urlParams = new URLSearchParams(window.location.search);
			urlParams.set('design', design?.design_id);
			urlParams.delete('variant');
			window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
			renderItems();
			requestAnimationFrame(() => {
				const designEl = document.querySelector(
					`.design-options-container .option-item[data-design-id="${design.design_id}"]`
				);
				designEl?.querySelector('label')?.click();
				designEl?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			});
		}
	});

	$('.saved-bg-close').on('click', function () {
		$(".saved-designs-drawer").removeClass("saved-designs-drawer--active");
		$("body").removeClass("saved-designs-drawer--active");
	});

	$('.product #umoq-save-btn').on('click', function (e) {
		e.preventDefault();
		const $btn = $(this);
		const $label = $btn.find('.umoq-save-btn__label');
		const original = $label.text();
		$btn.prop('disabled', true).find($label).text('Saving…');
		prodObj = $('.product')?.data('obj');
		umoqSession.setSessionMetadata({
			productId: prodObj?.productId,
			productHandle: prodObj?.productHandle,
			designName: prodObj?.productTitle,
			addToCart: `${window.location.origin}/products/${prodObj?.productHandle}?design=`
		});
		$.when(umoq.savePreview()).always(function (designObj) {
			$btn.prop('disabled', false).find($label).text(original);
			$('body, .saved-designs-drawer').addClass('saved-designs-drawer--active');
		});
	});

	renderItems();
}
savedDesignsInit();